import React from 'react'
import { useEffect } from 'react';
import { Footer } from '../../common/footer/footer';

import AOS from 'aos';
import 'aos/dist/aos.css';

const DisclosureJsx = () => {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, [])
 
  return (
    <>
      <section className="homecustom">
      <section className="termscondition">
        <div className="container">
          <div className="terminner mt-5 mb-5">
         <h2> Disclosure </h2>
         <div>
           <p>
           At RIMIB, our mission is to provide a comprehensive financial portal where you can easily access the best market offers and products, all at no cost to you. We connect you with licensed financial experts in your local community to help you make informed financial decisions. Please note, some of the products and offers featured on our site are from our clients, from whom we earn compensation. However, not all products or offers are part of these agreements, and we strive to provide valuable and accurate information. The offers/products displayed reflect the interests of our clients and may not represent all available options. The opinions and recommendations shared on our site are the authors' alone, based on their research and client relationships. We are confident that the offers can help you make wise decisions, but we always encourage you to do your own research or consult with a financial expert for personalized advice.
           </p>
         </div>
        </div>
        </div>
      </section>
        <Footer />
      </section>
    </>

  );
};

export default DisclosureJsx;
